var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"terminal-import"},[_c(_vm.dynamComp,{tag:"component",attrs:{"detailInfo":_vm.rowDetail},on:{"godetail":_vm.goInfo,"goback":_vm.handleBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }